import * as React from "react";
import classNames from "classnames";

interface ReasoningToolBarButtonProps {
  iconName?: string;
  isActive?: boolean;
  name: string;
  onToggle?: React.MouseEventHandler<HTMLAnchorElement>;
  openLink?: string;
  shouldShow: boolean;
  onExpand?: () => void;
};

const ReasoningToolBarButton = React.forwardRef<HTMLAnchorElement, ReasoningToolBarButtonProps>(({
  iconName,
  isActive = false,
  name = "",
  onToggle,
  openLink,
  shouldShow,
  onExpand,
}, ref) => {
  if (!shouldShow) { return null; }

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (openLink) {
      window.open(openLink, "_blank");
    } else if(onToggle) {
      onToggle(e);
      onExpand?.();
    }
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    // Activate on Space or Enter
    if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
      e.preventDefault();
      onClick((e as unknown) as React.MouseEvent<HTMLAnchorElement>);
    }
  };

  return (
    <a 
      ref={ref}
      href="#" 
      className={classNames("reasoning-tool-bar-button", {active: isActive})} 
      onClick={onClick}
      onKeyDown={onKeyDown}
      aria-expanded={isActive}
      tabIndex={0}
      role="button"
    >
      {iconName && <>
        <span className={iconName.slice(0,3) === "fa " ? iconName : `icon-lg ${iconName}`} aria-hidden="true" />
        <br />
      </>}
      <span className="button-name">{name}</span>
    </a>
  );
});

ReasoningToolBarButton.displayName = 'ReasoningToolBarButton';

export default ReasoningToolBarButton;
